import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import config from "../../../config";
import { login02,  loginlogo } from "../../imagepath";

const Register = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { phone } = location.state || {}; // Retrieve phone number from state
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Redirect to /login if phone is missing
  useEffect(() => {
    if (!phone) {
      navigate("/login");
    }
  }, [navigate, phone]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
    },
  });

  const handleFormSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_URL}register_user.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          phone, // Use phone from location.state
        }),
      });

      const responseData = await response.json();
      console.log("API Response:", responseData); // Debug log

      if (responseData.success === "1") {
        const { user_id, token } = responseData;
        localStorage.setItem("userUUID", user_id); // Store user_id as userUUID
        if (token) {
          localStorage.setItem("authToken", token); // Store token if provided
          console.log("Token stored:", token); // Debug log
        } else {
          console.warn("No token provided in response");
        }
        toast.success("Registration successful!");
        navigate("/", { replace: true }); // Navigate to success page
      } else {
        toast.error(responseData.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      toast.error("An error occurred during registration.");
    } finally {
      setLoading(false);
    }
  };

  const emailValue = watch("email");

  // Real-time email validation
  useEffect(() => {
    if (emailValue && !/^\S+@\S+\.\S+$/.test(emailValue)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  }, [emailValue]);

  return (
    <>
      <ToastContainer />
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            <div className="col-lg-6 login-wrap">
              <div className="login-sec">
                <div className="log-img">
                  <img className="img-fluid" src={login02} alt="Logo" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="#">
                          <img src={loginlogo} height={60} alt="Logo" />
                        </Link>
                      </div>
                      <h2>Getting Started</h2>
                      <form onSubmit={handleSubmit(handleFormSubmit)}>
                        <div className="form-group">
                          <label>
                            First Name <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("first_name", { required: "First Name is required" })}
                            placeholder="Enter your first name"
                            onChange={(e) => {
                              e.target.value = e.target.value
                                .split(/(\s+|\()/g)
                                .map((part, index, arr) =>
                                  part.length > 0
                                    ? part === "(" && index < arr.length - 1
                                      ? "("
                                      : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
                                    : part
                                )
                                .join("");
                              register("first_name").onChange(e); // Ensure react-hook-form updates
                            }}
                            onKeyPress={(e) => {
                              if (!/[A-Za-z\s()]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {errors.first_name && (
                            <span className="text-danger">{errors.first_name.message}</span>
                          )}
                        </div>
                        <div className="form-group">
                          <label>
                            Last Name <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("last_name", { required: "Last Name is required" })}
                            placeholder="Enter your last name"
                            onChange={(e) => {
                              e.target.value = e.target.value
                                .split(/(\s+|\()/g)
                                .map((part, index, arr) =>
                                  part.length > 0
                                    ? part === "(" && index < arr.length - 1
                                      ? "("
                                      : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
                                    : part
                                )
                                .join("");
                              register("last_name").onChange(e);
                            }}
                            onKeyPress={(e) => {
                              if (!/[A-Za-z\s()]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {errors.last_name && (
                            <span className="text-danger">{errors.last_name.message}</span>
                          )}
                        </div>
                        <div className="form-group">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^\S+@\S+\.\S+$/,
                                message: "Invalid email format",
                              },
                            })}
                            placeholder="Enter your email address"
                          />
                          {emailError && <span className="text-danger">{emailError}</span>}
                          {errors.email && <span className="text-danger">{errors.email.message}</span>}
                        </div>
                        <div className="form-group">
                          <label>
                            Phone Number <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={phone || ""}
                            readOnly
                          />
                        </div>
                        <div className="form-group login-btn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            disabled={loading}
                          >
                            {loading ? "Registering..." : "Sign up"}
                          </button>
                        </div>
                      </form>
                      {/* <div className="next-sign">
                        <p className="account-subtitle">
                          Already have an account? <Link to="/login">Login</Link>
                        </p>
                        <div className="social-login">
                          <img src={loginicon01} alt="Google" style={{ opacity: 0.5 }} />
                          <img src={loginicon02} alt="Facebook" style={{ opacity: 0.5 }} />
                          <img src={loginicon03} alt="Twitter" style={{ opacity: 0.5 }} />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;